// extracted by mini-css-extract-plugin
export default {"dlmText":"reset_dlmText__s17CE","container":"reset_container__CPvCR"};